import { useShowContext } from 'framework/show';
import useAuthenticatedUserService from 'infrastructure/security/authentication/authenticatedUserService';
import { useAsyncValue } from 'framework/utils';
import { DashboardEmployee } from '../types';
import { useCoordinatorManagement } from './useCoordinatorManagement';
import { useFollowUpManagement } from './useFollowUpManagement';
import { useZoneManagement } from './useZoneManagement';
import { useMenuOptions } from './useMenuOptions';

export const useDashboardCallbacks = () => {
  const { data } = useShowContext<DashboardEmployee>();
  const { getUserAlias } = useAuthenticatedUserService();
  const currentUserAlias = useAsyncValue(() => getUserAlias());

  const coordinatorManagement = useCoordinatorManagement();
  const followUpManagement = useFollowUpManagement();
  const zoneManagement = useZoneManagement();
  const menuManagement = useMenuOptions();

  const employeeData = data.getData();

  return {
    employeeData,
    ...menuManagement,
    ...followUpManagement,
    ...coordinatorManagement,
    ...zoneManagement,
    currentUserAlias: currentUserAlias || undefined,
    predefinedIssues: employeeData.retentionRiskIssues || [],
  };
};
